import { MapContainer, TileLayer, CircleMarker, Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const DENMARK_CENTER = [55.03, 9.42];
const DENMARK_ZOOM = 11;

function getColor(trivsel) {
  const val = parseFloat(trivsel);
  if (isNaN(val)) return "#888";
  if (val <= 12) return "#19945D";
  if (val <= 16) return "#6BAF5B";
  if (val <= 20) return "#F4C84D";
  if (val <= 28) return "#E8943A";
  return "#FF001E";
}

function FlyToSchool({ school }) {
  const map = useMap();
  if (school) {
    map.flyTo([school.lat, school.lon], 13, { duration: 0.8 });
  }
  return null;
}

export default function SchoolMap({ schools, selectedSchool, onSchoolSelect }) {
  return (
    <div className="map-container">
      <MapContainer
        center={DENMARK_CENTER}
        zoom={DENMARK_ZOOM}
        style={{ height: "100%", width: "100%" }}
        zoomControl={true}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap contributors, Tiles &copy; JFM'
          url="https://tiles.jfmtech.dk/styles/osm-bright/{z}/{x}/{y}.png"
        />
        <FlyToSchool school={selectedSchool} />
        {schools.map((school) => {
          const isSelected = selectedSchool?.skoleId === school.skoleId;
          return (
            <CircleMarker
              key={school.skoleId}
              center={[school.lat, school.lon]}
              radius={isSelected ? 10 : 6}
              pathOptions={{
                color: isSelected ? "#333" : getColor(school.socialtrivsel),
                fillColor: getColor(school.socialtrivsel),
                fillOpacity: isSelected ? 1 : 0.75,
                weight: isSelected ? 3 : 1,
              }}
              eventHandlers={{
                click: () => onSchoolSelect(school),
              }}
            >
              <Tooltip>
                <strong>{school.navn}</strong>
                <br />
                {school.kommune}
                <br />
                Social trivsel: {school.socialtrivsel}% negative
              </Tooltip>
            </CircleMarker>
          );
        })}
      </MapContainer>
      <div className="map-legend">
        <span className="legend-title">Social trivsel (% negative svar)</span>
        <div className="legend-items">
          <span><span className="dot" style={{ background: "#19945D" }} /> &le;12%</span>
          <span><span className="dot" style={{ background: "#6BAF5B" }} /> 12-16%</span>
          <span><span className="dot" style={{ background: "#F4C84D" }} /> 16-20%</span>
          <span><span className="dot" style={{ background: "#E8943A" }} /> 20-28%</span>
          <span><span className="dot" style={{ background: "#FF001E" }} /> &gt;28%</span>
        </div>
      </div>
    </div>
  );
}
